module.exports = __webpack_public_path__ + "static/media/code.fc471d5b.png";